module.exports = "<div #googleMap style=\"width: 100%; height: 100%;\"></div>\r\n<!-- width width-100-percent height height-100-percent -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/google-maps/google-maps.component.html
// module id = 2327
// module chunks = 66